module.exports = __webpack_public_path__ + "static/vucaro-14fad0ba6fd14b7ebc2d02a2cc5f8d9e.svg";